// Nexfah Brand Colors - Derived from logo gradient
// Logo uses cyan (#00D4FF) to royal blue (#5B8DEF) gradient

export const palette = {
  // Primary colors - Cyan spectrum from logo
  primary: {
    main: '#00B8D4',
    light: '#00E5FF',
    dark: '#0097A7',
    contrastText: '#FFFFFF',
  },
  // Secondary colors - Blue spectrum from logo
  secondary: {
    main: '#5B8DEF',
    light: '#8BB4F8',
    dark: '#3D6FD9',
    contrastText: '#FFFFFF',
  },
  // Accent gradient colors
  accent: {
    cyan: '#00D4FF',
    teal: '#00B8D4',
    blue: '#4FC3F7',
    royal: '#5B8DEF',
    gradient: 'linear-gradient(135deg, #00D4FF 0%, #5B8DEF 100%)',
    gradientHover: 'linear-gradient(135deg, #00E5FF 0%, #8BB4F8 100%)',
    gradientDark: 'linear-gradient(135deg, #0097A7 0%, #3D6FD9 100%)',
  },
  // Neutral colors
  grey: {
    50: '#FAFAFA',
    100: '#F5F5F5',
    200: '#EEEEEE',
    300: '#E0E0E0',
    400: '#BDBDBD',
    500: '#9E9E9E',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
  },
  // Background colors
  background: {
    default: '#FFFFFF',
    paper: '#FFFFFF',
    dark: '#0A1628',
    gradient: 'linear-gradient(180deg, #FAFAFA 0%, #FFFFFF 100%)',
    hero: 'linear-gradient(135deg, #0A1628 0%, #1A2942 50%, #0D2137 100%)',
  },
  // Text colors
  text: {
    primary: '#1A2942',
    secondary: '#5A6A7E',
    disabled: '#9E9E9E',
    light: '#FFFFFF',
  },
  // Status colors
  success: {
    main: '#10B981',
    light: '#34D399',
    dark: '#059669',
  },
  warning: {
    main: '#F59E0B',
    light: '#FBBF24',
    dark: '#D97706',
  },
  error: {
    main: '#EF4444',
    light: '#F87171',
    dark: '#DC2626',
  },
  info: {
    main: '#3B82F6',
    light: '#60A5FA',
    dark: '#2563EB',
  },
};

// Dark mode palette
export const darkPalette = {
  ...palette,
  background: {
    default: '#0A1628',
    paper: '#1A2942',
    dark: '#050D1A',
    gradient: 'linear-gradient(180deg, #0A1628 0%, #1A2942 100%)',
    hero: 'linear-gradient(135deg, #0A1628 0%, #1A2942 50%, #0D2137 100%)',
  },
  text: {
    primary: '#FFFFFF',
    secondary: '#B0BEC5',
    disabled: '#616161',
    light: '#FFFFFF',
  },
};

export default palette;
